module.exports = __webpack_public_path__ + "img/202506_02.828fe253.jpg";